export var isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;